<template>
    <div
        class="c-search"
        :class="{ 'c-search--mini': mini }"
        v-on-clickaway="closeSearch"
    >
        <div class="c-search__button" v-if="mini" @click="showInput()">
            {{ translations['Search'] }}

            <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M5.8077 12.0398C2.57829 12.0398 -1.17472e-07 9.35235 -2.60159e-07 6.08805C-4.02874e-07 2.82311 2.57821 0.135583 5.8077 0.135583C9.03799 0.135583 11.6154 2.82319 11.6154 6.08805C11.6154 9.35227 9.03791 12.0398 5.8077 12.0398ZM1.6916 6.08805C1.69161 8.46388 3.55767 10.3482 5.8077 10.3482C8.05838 10.3482 9.92379 8.46396 9.92379 6.08805C9.92379 3.71133 8.0583 1.82719 5.8077 1.82719C3.55775 1.82719 1.6916 3.71142 1.6916 6.08805Z"
                    fill="#313131"
                />
                <path
                    d="M8.94512 10.4554L11.6605 13.2258C11.7488 13.317 11.8548 13.3895 11.9721 13.4391C12.0894 13.4887 12.2155 13.5143 12.3431 13.5144C12.4706 13.5145 12.5968 13.4891 12.7142 13.4397C12.8315 13.3903 12.9376 13.318 13.0261 13.227C13.2071 13.0394 13.308 12.7899 13.3078 12.5304C13.3075 12.2709 13.2062 12.0215 13.0249 11.8342L10.309 9.06442C9.93232 8.68189 9.32058 8.67957 8.94395 9.06326C8.76211 9.24982 8.66097 9.49938 8.66206 9.75876C8.66206 10.0103 8.75563 10.263 8.94512 10.4554V10.4554Z"
                    fill="#313131"
                />
            </svg>
        </div>
        <div class="c-search__inputholder" v-if="(mini && show) || !mini">
            <input
                class="c-search__input"
                :class="{ 'c-search__input--active': products }"
                :placeholder="translations['Search products...']"
                v-model="searchString"
                @keyup.esc="closeSearch"
                @focus="showClear = true"
                ref="searchInput"
            />
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 72 72"
                class="c-search__load-icon"
                v-if="isLoading"
            >
                <g data-name="Layer 2">
                    <path
                        d="M36 57.75a21.75 21.75 0 0 1 0-43.5V0a36 36 0 1 0 36 36H57.76A21.75 21.75 0 0 1 36 57.75z"
                        fill="#313131"
                        data-name="Layer 1"
                    />
                </g>
            </svg>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                class="c-search__close-icon"
                v-if="!isLoading && showClear"
                @click="clearInput()"
            >
                <path
                    d="M9,3 C9.55228475,3 10,3.44771525 10,4 L10,8 L14,8 C14.5522847,8 15,8.44771525 15,9 C15,9.55228475 14.5522847,10 14,10 L10,10 L10,14 C10,14.5522847 9.55228475,15 9,15 C8.44771525,15 8,14.5522847 8,14 L8,10 L4,10 C3.44771525,10 3,9.55228475 3,9 C3,8.44771525 3.44771525,8 4,8 L8,8 L8,4 C8,3.44771525 8.44771525,3 9,3 Z"
                    opacity=".6"
                    transform="rotate(45 9 9)"
                />
            </svg>
        </div>
        <transition name="fade">
            <div class="c-search__dropdown" v-if="products">
                <div
                    class="c-search__result c-search__result--empty"
                    v-if="!products.length"
                >
                    {{
                        translations[
                            'Sorry, we did not find any matching products'
                        ]
                    }}
                </div>
                <div class="c-search__results">
                    <a
                        :href="product.link"
                        class="c-search__result"
                        v-for="product in this.products"
                        :key="product.isLoading"
                    >
                        <img :src="product.image" />
                        <div>
                            <div class="name">{{ product.title }}</div>
                            <div class="price">{{ product.price }}</div>
                        </div>
                    </a>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { mixin as clickaway } from 'vue-clickaway'
import { debounce } from '../scripts/helpers'

export default {
    name: 'Search',
    props: {
        mini: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            searchString: '',
            products: null,
            isLoading: false,
            show: false,
            showClear: false,
        }
    },
    computed: {
        ...mapState({
            translations: (state) => state.app.translations,
        }),
    },
    mixins: [clickaway],
    watch: {
        searchString(string) {
            this.inputChanged(string, this)
            if (string) {
                this.$nextTick(() => {
                    this.$refs.searchInput.focus()
                })
            }
        },
    },
    methods: {
        clearInput() {
            this.searchString = ''
        },
        showInput() {
            this.show = true
            this.$nextTick(() => {
                this.$refs.searchInput.focus()
            })
        },
        inputChanged: debounce((string, vm) => {
            vm.searchFor = string
            vm.getResults()
        }, 500),

        getResults() {
            if (this.searchFor.length > 2) {
                this.results = []

                this.isLoading = true

                axios
                    .get('/api/qd/search/' + this.searchFor.replace(' ', '%20'))
                    .then((response) => {
                        this.products = response.data
                        this.isLoading = false
                    })
                    .catch((e) => {
                        // console.log(e)
                    })
            }
        },
        closeSearch() {
            this.searchString = ''
            this.products = null
            this.show = false
            this.showClear = false
            if (this.$refs.searchInput) {
                this.$refs.searchInput.blur()
            }
        },
    },
}
</script>

<style lang="scss">
@import '../../scss/abstracts/variables.scss';

.c-search {
    $root: &;

    position: relative;
    width: 100%;
    max-width: 550px;

    &__dropdown {
        position: absolute;
        z-index: 5;
        top: -10px;
        padding-top: 57px;
        width: 100%;
        background: $c-white;
        filter: drop-shadow(-2px -2px 4px rgba(0, 0, 0, 0.16));
        border-radius: 4px;
    }

    &__results {
        height: 100%;
        max-height: 450px;
        overflow-y: auto;
        scrollbar-width: thin;
        scrollbar-color: $c-black rgba($c-black, 0.4);
        &::-webkit-scrollbar {
            width: 10px;
            height: 2px;

            &-button {
                width: 0;
                height: 0;
            }

            &-corner {
                background: transparent;
            }

            &-thumb {
                background: $c-black;
                border: 0 none #fff;
                border-radius: 0;
            }

            &-track {
                background: rgba($c-black, 0.1);
                border: 0 none #fff;
                border-radius: 0;
            }
        }
    }

    &__result {
        display: flex;
        padding: 20px;
        border-bottom: 1px solid $c-light-grey;
        transition: all $t-hover;

        img {
            max-width: 45px;
            min-width: 45px;
            max-height: 45px;
            margin-top: -2px;
            height: auto;
            margin-right: 16px;
        }

        .name {
            color: $c-black;
            font-family: $font-heading;
            text-transform: uppercase;
            font-size: 20px;
            letter-spacing: -0.15px;
            line-height: 20px;
        }

        .price {
            margin-top: 4px;
            font-family: $font-heading;
            text-transform: uppercase;
            font-size: 16px;
            letter-spacing: -0.15px;
            line-height: 20px;
        }

        &:hover {
            background: $c-white-smoke;
            cursor: pointer;
        }

        &--empty {
            font-size: 14px;
            padding: 20px 35px;
            &:hover {
                cursor: initial;
                background: $c-white;
            }
        }
    }

    &__input {
        width: calc(100% - 20px);
        padding: 15px 27px 15px;
        border: 1px solid #e3e3e3;
        border-radius: 25px;
        background-color: #f9f9f9;
        transition: all 0.3s $t-nice;
        &:focus {
            background: $c-white;
        }

        &:hover {
            border-color: #cecece;
        }

        &--active {
            border-radius: 0;
            border: none;
            border-bottom: 1px solid #e3e3e3;
            background: $c-white;
            width: calc(100% - 40px);
            padding: 15px 15px 15px;
        }
    }

    &__inputholder {
        display: flex;
        justify-content: center;
        width: 100%;
        position: relative;
        z-index: 6;
    }

    &__load-icon {
        width: 23px;
        height: 23px;
        position: absolute;
        right: 15px;
        top: 12px;
        animation: search-load 0.8s linear infinite;
    }

    &__close-icon {
        width: 23px;
        height: 23px;
        position: absolute;
        right: 25px;
        top: 12px;
        &:hover {
            cursor: pointer;
        }
    }

    &__button {
        border-left: 1px solid #ededed;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 0 0 16px;
        font-size: 11px;
        font-weight: 700;
        letter-spacing: -0.08px;
        line-height: 13px;
        text-transform: uppercase;
        svg {
            margin-left: 9px;
        }
    }

    &--mini {
        width: auto;

        #{$root} {
            &__inputholder {
                position: absolute;
                top: 2px;
                bottom: 2px;
                right: -108px;
                min-width: 100vw;
            }

            &__dropdown {
                right: -108px;
                min-width: 100vw;
            }
        }
    }
}
</style>
